let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2MFVe")).then(() => parcelRequire('3FCPe'));